import { render, staticRenderFns } from "./MetaVegetal.vue?vue&type=template&id=1dc299dd&scoped=true"
import script from "./MetaVegetal.vue?vue&type=script&lang=js"
export * from "./MetaVegetal.vue?vue&type=script&lang=js"
import style0 from "./MetaVegetal.vue?vue&type=style&index=0&id=1dc299dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc299dd",
  null
  
)

export default component.exports